import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const ApplicationCountryNameFilter = ({
  label = "l.searchFilter.applicationCountryName",
  ...others
}: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"applicationCountryName"} label={label} {...others} />
    </>
  );
};

export default ApplicationCountryNameFilter;
